import {
  Box, Button, CircularProgress, Dialog,
  DialogContent,
  DialogTitle,
  FormControl,
  IconButton,
  Paper,
  RadioGroup, TextField,
  Typography,
} from "@mui/material";
import { Colors } from "../../helpers/Consts";
import * as CompositionPricing from "../../helpers/Composition";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import {
  ICompositionGroup,
  ICompositionGroupItemList,
  ICompositionGroupList,
  ICompositionItemObject, IProduct, IProductFull, isProductFullDataFlavourControl,
} from "../../types/Product";
import { Fragment, useEffect, useState } from "react";
import { useFormik } from "formik";
import logger from "../../components/Logger";
import { IAddItemShoppingBagParams, IShoppingBagData } from "../../types/ShoppingBag";
import { useMutationAddItemShoppingBag } from "../../services/api/mutations/useMutationAddItemShoppingBag";
import { QueryObserverResult, RefetchOptions, RefetchQueryFilters } from "react-query";
import {cloneDeep} from "lodash";
import SeletorAlternativa from "./components/SeletorAlternativa";
import SeletorQuantidadeDoItemOuSabor from "./components/SeletorQuantidadeDoItemOuSabor";
import SeletorCheckboxes from "./components/SeletorCheckboxes";
import SeletorDeQuantidadeDeSabores from "./components/SeletorDeQuantidadeDeSabores";
import PriceTag from "./components/priceTag";

type Props = {
  open: boolean;
  handleClose: () => void;
  fullScreen:boolean;
  apiProductData: IProductFull;
  productDataRefetch: (options?: ((RefetchOptions & RefetchQueryFilters) | undefined)) => Promise<QueryObserverResult<IProductFull, unknown>>
  product: IProduct;
  shoppingBag:IShoppingBagData
  placeEstaFechado: boolean;
};

/**
 * DELIVERY: aqui é para usuário poder adicionar produtos à sacola.
 * @param apiProductData
 * @param productDataRefetch
 * @param product
 * @param open
 * @param handleClose
 * @param fullScreen
 * @param shoppingBag
 * @param placeEstaFechado
 * @constructor
 */
export default function FoodDialogForm({apiProductData, productDataRefetch, product, open, handleClose, fullScreen, shoppingBag,placeEstaFechado}: Props){
  const productData = apiProductData.data;

  const { mutate:addProductToBag } = useMutationAddItemShoppingBag();

  const formik = useFormik({
    enableReinitialize: true,
    onReset:(values, formikHelpers)=>{
      if(formik.isSubmitting){
        logger.log('tentando resetar enquanto está submitting')
        return;
      }

      if(!shoppingBag) return;
      if(!productData) return;

      formik.values.user_order_id = shoppingBag.id;
      formik.values.product_id = productData.id;
      formik.values.quantity = 1;
      formik.values.unit_price = productData.new_price;
      formik.values.total_price = productData.new_price;
      formik.values.flavour_control = false;
      formik.values.observations = "";
      formik.values.compositionGroupItemList = productData.compositionGroupItemList;
      formik.values.total_value = 0;
      formik.values.compositionGroupInfo = productData.compositionGroupList;

      logger.log('formik on reset do FoodCard')
    },

    initialValues: {
      user_order_id: shoppingBag?.id ?? 123,
      product_id: productData?.id,
      quantity: 1,
      unit_price: productData?.new_price,
      total_price: productData?.new_price,
      flavour_control: false,
      observations: "",
      compositionGroupItemList: productData?.compositionGroupItemList,
      total_value: 0,
      compositionGroupInfo: productData?.compositionGroupList,
    } as IAddItemShoppingBagParams,

    onSubmit: async (values, formikHelpers) => {
      const toSend = cloneDeep(values)
      toSend.compositionGroups = new Array<ICompositionGroup>();

      toSend.flavour_control = isProductFullDataFlavourControl(productData)

      toSend.item_description = productData.name.slice(0, 14)
      toSend.compositionGroupInfo?.map((category) => {
        const compositionGroup = {
          composition_group_id: category.id,
          compositionGroupItems: new Array<ICompositionItemObject>(),
        } as ICompositionGroup;
        toSend.compositionGroups.push(compositionGroup);
        toSend.compositionGroupItemList
          .filter((item) => item.product_composition_id === category.id)
          .forEach((itemF) => {
            toSend.compositionGroups?.map((group) => {
              if (group.composition_group_id === itemF.product_composition_id) {
                const itemObject = {
                  composition_item_id: itemF.id,
                  name: itemF.name,
                  price: itemF.price,
                  quantity: itemF.quantity,
                  total: itemF.price,
                } as ICompositionItemObject;
                group.compositionGroupItems.push(itemObject);
              }
            });
          });
      });
      setTimeout(()=>{
        handleClose();
      }, 550)
      addProductToBag(toSend);
    },
  });

  // Handle Quantidade Produto Total
  const handleQuantity = (action: string) => {
    if (action === "add") {
      formik.setFieldValue("quantity", formik.values.quantity + 1, true);
      formik.setFieldValue(
        "total_value",
        (formik.values.unit_price + CompositionPricing.getPriceCompositionOnCreating(formik.values.compositionGroupItemList, formik.values.compositionGroupInfo)) *
        (formik.values.quantity + 1),
        true
      );
    } else {
      formik.setFieldValue("quantity", formik.values.quantity - 1, true);
      formik.setFieldValue(
        "total_value",
        (formik.values.unit_price + CompositionPricing.getPriceCompositionOnCreating(formik.values.compositionGroupItemList, formik.values.compositionGroupInfo)) *
        (formik.values.quantity - 1),
        true
      );
    }
  };

  useEffect(() => {
    return ()=>{ productDataRefetch() }
  }, []);

  // Handle Quantidade por Categoria ( Composições )
  function getSumSelectedSubItems(category: ICompositionGroupList) {
    const array = formik.values.compositionGroupItemList?.filter(
      (item) => item.product_composition_id === category.id
    );
    return array?.reduce((accumulator, obj) => {
      return accumulator + obj.quantity;
    }, 0);
  }

  // Handle Item por Composição (Composições )
  const handleCompositionItem = (
    item: ICompositionGroupItemList,
    action: string,
    category: ICompositionGroupList
  ) => {
    logger.log('handleCompositionItem')
    if (action === "add") {
      if (getSumSelectedSubItems(category) < category.max) {
        formik.values.compositionGroupItemList[
          formik.values.compositionGroupItemList.indexOf(item)
          ].quantity += 1;
      }
    } else {
      formik.values.compositionGroupItemList[
        formik.values.compositionGroupItemList.indexOf(item)
        ].quantity -= 1;
    }

    formik.setFieldValue(
      "compositionGroupItemList",
      formik.values.compositionGroupItemList,
      true
    );
    formik.setFieldValue(
      "total_value",
      (formik.values.unit_price + CompositionPricing.getPriceCompositionOnCreating(formik.values.compositionGroupItemList, formik.values.compositionGroupInfo)) *
      formik.values.quantity,
      true
    );
  };

  const valorFinal =
    formik.values.total_value !== 0
      ? (formik.values.total_value ?? 0)
      : (formik.values.unit_price ?? 0)

  function emReal(valor: number): string {
      return valor.toLocaleString("pt-br", {
        style: "currency",
        currency: "BRL",
        minimumFractionDigits: 2,
      })
    }

  function emDecimal(valor:number): string {
      return valor.toLocaleString("pt-br", {
        minimumFractionDigits: 2,
      })
    }

  // Handle Disable Button se for Composição e não tiver Completo
  function handleDisabledButtonComposition(): boolean {
    if (productData?.compositionGroupList.length) {
      if (
        productData?.compositionGroupList.some(
          (category) =>
            !isQuantidadeItensEscolhidosSuficiente(category)
        )
      ) {
        return true;
      }
    }
    return false;
  }

  // Handle Select RadioButtons
  const handleSelect = (
    item: ICompositionGroupItemList,
    category: ICompositionGroupList,
    categoryId?: number
  ) => {
    const itemFound = formik.values.compositionGroupItemList.find(
      (itemF) =>
        itemF.quantity === 1 && itemF.product_composition_id === categoryId
    );

    if (item.quantity === 0) {
      formik.values.compositionGroupItemList[
        formik.values.compositionGroupItemList.indexOf(item)
        ].quantity = 1;
    }
    if (itemFound && itemFound.product_composition_id === categoryId) {
      itemFound.quantity -= 1;
    }
    formik.setFieldValue(
      "total_value",
      (formik.values.unit_price + CompositionPricing.getPriceCompositionOnCreating(formik.values.compositionGroupItemList, formik.values.compositionGroupInfo)) *
      formik.values.quantity,
      true
    );
    formik.setFieldValue(
      "compositionGroupItemList",
      formik.values.compositionGroupItemList,
      true
    );
  };

  /**
   * Mapa da escolha que o usuário fez de quantos sabores ele quer numa category que controla sabores (flavour_control)
   *  OBS: em teoria, era para poder funcionar com produtos permitindo mais de uma categoria que escolhe sabores.
   *       Na prática, os produtos só vão ter no máximo uma categoria com sabor (pelo menos assim que está definido
   *       o cadastro de produtos lá no Restaurante Desktop. O problema na verdade é que o Restaurante desktop só permite
   *       uma categoria com sabor, para produtos lançados pelo Restaurante Desktop. Talvez poderia lançar lá como kit ou combo...
   *       mas de qualquer forma, o ponto é que na prática por enquanto não vai ter produto com mais de uma categoria que
   *       controla sabores.
   *
   * key: id da categoria
   * value: quantidade escolhida para sabores
   */
  const [qtdsMaximasDeSaboresPorCategoriaEscolhidasPeloUsuario, setQtdsMaximasDeSaboresPorCategoriaEscolhidasPeloUsuario]
    = useState<Map<number, number>>(new Map());


  // resetar o mapa de escolhas de sabores quando o dialog fecha
  useEffect(() => {
    if(open){
      const categoriasDeSaborComOpcaoMaximaDe1 = productData?.compositionGroupList.filter(
        (category) => category.flavour_control && category.max === 1
      )

      if(categoriasDeSaborComOpcaoMaximaDe1.length > 0){
        categoriasDeSaborComOpcaoMaximaDe1.forEach((category) => {
          selecionaQuantidadeDeSabor(category.id, 1)
        })
      }
    }

    if(!open){
      setQtdsMaximasDeSaboresPorCategoriaEscolhidasPeloUsuario(new Map());
      productData?.compositionGroupItemList.forEach((item) => {
        item.quantity = 0;
      })
    }
  }, [open])

  function selecionaQuantidadeDeSabor(idCategoria: number, qtdEscolhida: number){
    setQtdsMaximasDeSaboresPorCategoriaEscolhidasPeloUsuario((prevState) => {
      const newState = new Map(prevState);
      newState.set(idCategoria, qtdEscolhida);
      return newState;
    })
  }

  const seletorDeItem = (item: ICompositionGroupItemList, category: ICompositionGroupList) =>{
    // atenção:
    // pensar da seguinte forma em relação a esta function:
    // os parametros que recebemos (item e category) são uma lista para 'exibição',
    // o 'model' que vamos enviar ao adicionar na shoppingBag está no formik
    // portanto: ao clicar em um item, devemos alterar o formik.values.etcAlgumaCoisa...
    // ou de outra forma: temos que linkar o item clicado com o formik.values.compositionGroupItemList
    const itemDoFormik = formik.values.compositionGroupItemList?.find(
      (itemF) => itemF.id === item.id
    );

    if(category.max === 1){
      return (<SeletorAlternativa
        handleSelect={() => handleSelect(item, category, item.product_composition_id)}
        value={item.name}
        checked={
          formik.values.compositionGroupItemList
          && formik.values.compositionGroupItemList.length
            ? formik.values.compositionGroupItemList.find(
            ( item2: ICompositionGroupItemList ) =>
              item2.quantity === 1 && item2.name === item.name
          )?.id === item.id
            : false
        }/>)
    }

    if(category.flavour_control){
      const totalSaboresEscolhidos = getSumSelectedSubItems(category);
      const qtdMaxEscolhidaPeloUsuario = qtdsMaximasDeSaboresPorCategoriaEscolhidasPeloUsuario.get(category.id);
      return(
        <SeletorCheckboxes
          handleSelect={() =>{
            // alterna entre qtd 1 e 0, apenas
            if(!itemDoFormik) return;
            itemDoFormik.quantity === 1
            ? handleCompositionItem(item, "remove", category)
            : handleCompositionItem(item, "add", category)}
        }
          value={item.name}
          checked={itemDoFormik?.quantity === 1}
          disabled={qtdMaxEscolhidaPeloUsuario === undefined // usuário ainda não escolheu a quantidade de sabores
            || (itemDoFormik?.quantity === 0 && totalSaboresEscolhidos === qtdMaxEscolhidaPeloUsuario)}
          />
      )
    }

    return(
      <>
      <SeletorQuantidadeDoItemOuSabor
        selectedQuantity={item.quantity}
        handleAdd={() => handleCompositionItem(item, "add", category)}
        handleSubtract={() => handleCompositionItem(item, "remove", category)}
        addDisabled={
          getSumSelectedSubItems(category) === category.max
          /*|| item.quantity === 1*/
        }
        subtractDisabled={item.quantity === 0}
      />
      </>)
  }

  const isQuantidadeItensEscolhidosSuficiente = (category: ICompositionGroupList) => {
    if(category.flavour_control) {
      return qtdsMaximasDeSaboresPorCategoriaEscolhidasPeloUsuario.get(category.id) === getSumSelectedSubItems(category)
    }

    if(!category.mandatory) return true;

    // se não controla sabores, a qtd escolhida está entre min e max?
    const qtdSelecionada = getSumSelectedSubItems(category);

    return qtdSelecionada <= category.max
            && qtdSelecionada >= category.min
  }

  return(<Dialog
    fullScreen={fullScreen}
    open={open}
    onClose={() => {
      handleClose();
    }}
    maxWidth={"lg"}
  >
    <DialogTitle color={Colors.orangePrimary}>
      <Box display="flex" alignItems="center">
        <Box>
          <IconButton
            color="primary"
            onClick={async () => {
                //productDataRefetch();
              handleClose();
            }}
          >
            <ArrowBackIosIcon fill={Colors.orangePrimary} />
          </IconButton>
        </Box>
        <Box
          flexGrow={1}
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          Detalhes do Item
        </Box>
      </Box>
    </DialogTitle>
    <DialogContent>
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          width: { md: "600px" },
          height: "100%",
        }}
      >
        <form
          noValidate
          onSubmit={formik.handleSubmit}
          style={{
            display: "flex",
            flexDirection: "column",
            height: "100%",
            padding: 1,
          }}
        >
          <Box display="flex" alignItems="center" justifyContent="center">
            {productData?.image ? (
              <Box
                component="img"
                sx={{
                  borderRadius: "7px",
                  width: {
                    xs: "180px",
                    sm: "200px",
                    md: "280px",
                  },
                  height: {
                    xs: "180px",
                    sm: "200px",
                    md: "280px",
                  },
                }}
                src={productData?.image}
                alt={productData?.name}
              />
            ) : (
              <Box
                component="img"
                sx={{
                  borderRadius: "7px",
                  width: {
                    xs: "180px",
                    sm: "200px",
                    md: "280px",
                  },
                  height: {
                    xs: "180px",
                    sm: "200px",
                    md: "280px",
                  },
                }}
                src={require("assets/img/noImageProduct.png")}
                alt={productData?.name}
              />
            )}
          </Box>
          <Box marginTop={2}>
            <Typography
              fontSize="16px"
              fontWeight={"700"}
              color={Colors.grayTextColorDarkestDark}
            >
              {productData?.name}
            </Typography>
            <Typography
              fontSize="12px"
              color={Colors.baseTextColor}
              marginTop="4px"
            >
              {productData?.description}
            </Typography>

            {product?.show_people_served_information ? (<Typography
              fontSize="10px"
              color={Colors.baseTextColor}
              marginTop="2px"
            >
              Serve até {productData?.people_served} pessoa(s)
            </Typography>) : null}
            <Box
              sx={{
                display: "flex",
              }}
            >
              <PriceTag product={product} />

            </Box>
            <Box>
              {/* CATEGORIAS DE SUBITENS ********************************************************************/}
              {productData?.compositionGroupList.map(
                (category: ICompositionGroupList) => (
                  <Fragment key={category.id}>
                    <SeletorDeQuantidadeDeSabores
                      category={category}
                      onSelecionaQuantidadeDeSabor={selecionaQuantidadeDeSabor}
                      seTelaEditarQuantosSaboresJaSelecionados={undefined}
                    />
                    <Box
                      sx={{
                        padding: '5px',
                        backgroundColor: 'lightGray',
                        display: "flex",
                      }}
                    >
                      <Box>
                        <Typography
                          style={{
                            fontWeight: 700,
                            fontSize: "13px",
                          }}
                        >
                          {category.description}
                        </Typography>

                        <Typography
                          color={Colors.baseTextColor}
                          style={{
                            fontWeight: 400,
                            fontSize: "12px",
                          }}
                        >
                          {
                            category.flavour_control
                            ? !qtdsMaximasDeSaboresPorCategoriaEscolhidasPeloUsuario.get(category.id)
                               ? `Escolha os sabores`
                                : `${getSumSelectedSubItems(category)} de ${qtdsMaximasDeSaboresPorCategoriaEscolhidasPeloUsuario.get(category.id)}`
                            :`${getSumSelectedSubItems(category)} de ${category.max}`
                          }
                        </Typography>
                      </Box>
                      <Box flexGrow={1} />
                      <Box>
                        {
                          // se controla sabores, escolheu todos?
                          (isQuantidadeItensEscolhidosSuficiente(category))
                            // exibe OK:
                          ? (<Paper
                              sx={{
                                paddingX: "4px",
                                paddingY: "4px",
                                backgroundColor: category.mandatory
                                  ? "green"
                                  : Colors.grayTextColorDark,
                                minWidth: "58.77px",
                                textAlign: "center",
                              }}
                              variant="elevation"
                              elevation={3}
                            >
                            <Typography fontSize={"10px"} color="white">
                              OK
                            </Typography>
                          </Paper>)

                          // Se não, exibe Obrigatório ou Opcional
                        : (<Paper
                            sx={{
                              paddingX: "4px",
                              paddingY: "4px",
                              minWidth: "58.77px",
                              backgroundColor: category.mandatory
                                ? "red"
                                : Colors.grayTextColorDark,
                              textAlign: "center",
                            }}
                            variant="elevation"
                            elevation={3}
                          >
                            <Typography fontSize={"10px"} color="white">
                              {category.mandatory
                                ? "Obrigatório"
                                : "Opcional"}
                            </Typography>
                          </Paper>
                        )}
                      </Box>
                    </Box>
                    <FormControl fullWidth>
                      <RadioGroup
                        name={category.description + category.id}
                      >
                        {/* SUBITENS (sabores, opcionais, adicionais etc)********************************************************************/}
                        {productData?.compositionGroupItemList
                          .filter(
                            (itens: ICompositionGroupItemList) =>
                              itens.product_composition_id === category.id
                          )
                          .map((item: ICompositionGroupItemList, index: number) => (
                            <Box
                              sx={{
                                marginBottom: "8px",
                                display: "flex",
                                alignItems: "center",
                                backgroundColor: index % 2 === 0 ? 'none' : "#f9f4f4",
                              }}
                              key={item.id}
                            >
                              <Box>
                                <Typography
                                  style={{
                                    paddingLeft: "8px",
                                    fontWeight: 400,
                                    fontSize: "12px",
                                  }}
                                >
                                  {item.name}
                                </Typography>
                                <Typography
                                  style={{
                                    paddingLeft: "8px",
                                    paddingRight: "8px",
                                    fontWeight: 400,
                                    fontSize: "11px",
                                    color: Colors.grayTextColorDarkest,
                                  }}
                                >
                                  {item.description}
                                </Typography>
                                <Typography
                                  color={Colors.baseTextColor}
                                  style={{
                                    paddingLeft: "8px",
                                    fontWeight: 400,
                                    fontSize: "11px",
                                  }}
                                >
                                  {emReal(item.price)}
                                </Typography>
                              </Box>
                              <Box flexGrow={1} />
                              <Box
                                sx={{
                                  display: "flex",
                                  alignItems: "center",
                                }}
                              >
                                {seletorDeItem(item, category)}
                              </Box>
                            </Box>
                          ))}
                      </RadioGroup>
                    </FormControl>
                  </Fragment>
                )
              )}
            </Box>
            <>
               <Typography
                variant="body2"
                color="black"
                style={{
                  fontWeight: 700,
                  fontSize: "12px",
                  marginTop: "12px",
                }}
              >
                Observações?
              </Typography>
              <TextField
                sx={{ marginTop: "5px" }}
                fullWidth
                id="observations"
                placeholder="Ex: Não colocar salada, ketchup a parte, etc."
                variant="standard"
                onChange={formik.handleChange}
                value={formik.values.observations}
              />
              </>
          </Box>
            <Box marginTop="auto">
              <Box
                sx={{
                  display: "flex",
                  alignItems: "flex-end",
                  justifyContent: "flex-end",
                  marginTop: "5px",
                }}
              >
                <Button
                  variant="contained"
                  sx={{
                    fontSize: "20px",
                    color: "white",
                    minWidth: "30px",
                    maxHeight: "30px",
                    width: "30px",
                  }}
                  onClick={() => {
                    handleQuantity("remove");
                  }}
                  disabled={formik.values.quantity === 1}
                >
                  -
                </Button>
                <Button
                  variant="contained"
                  sx={{
                    fontSize: "20px",
                    color: "white",
                    minWidth: "30px",
                    maxHeight: "30px",
                    width: "30px",
                    marginLeft: "5px",
                  }}
                  onClick={() => {
                    handleQuantity("add");
                  }}
                >
                  +
                </Button>
              </Box>
              <Box
                sx={{
                  display: "flex",
                  alignItems: "flex-end",
                  justifyContent: "center",
                }}
              >
                <Typography
                  fontSize="11px"
                  style={{ fontWeight: 400 }}
                  color={Colors.grayTextColorDarkestDark}
                >
                  TOTAL
                </Typography>
                <Box sx={{ flexGrow: 1 }} />
                <Typography
                  fontSize="11px"
                  style={{ fontWeight: 400 }}
                  color={Colors.grayTextColorDarkestDark}
                >
                  QUANT.
                </Typography>
              </Box>
              <Box
                sx={{
                  display: "flex",
                  alignItems: "flex-end",
                  justifyContent: "center",
                }}
              >
                <Typography
                  fontSize="11px"
                  style={{ fontWeight: 400 }}
                  color={Colors.grayTextColorDarkestDark}
                >
                  R$
                </Typography>
                <Typography
                  fontSize="16px"
                  style={{ fontWeight: 700, paddingLeft: '5px' }}
                  color={Colors.grayTextColorDarkestDark}
                >
                  {emDecimal(valorFinal)}
                </Typography>
                <Box sx={{ flexGrow: 1 }} />
                <Typography
                  fontSize="16px"
                  style={{ fontWeight: 700 }}
                  color={Colors.grayTextColorDarkestDark}
                >
                  x{formik.values.quantity}
                </Typography>
              </Box>
            </Box>
            <Box sx={{ width: "100%" }}>
              <Button
                sx={{
                  width: "100%",
                  color: "white",
                  textTransform: "none",
                }}
                type="submit"
                variant="contained"
                disabled={handleDisabledButtonComposition() || formik.isSubmitting || (placeEstaFechado)}
              >
                {formik.isSubmitting ? 'Adicionando...' : 'Adicionar'}{" "}
                {emReal(valorFinal)}
                {(formik.isSubmitting) && (<div style={{ margin: "auto 15px" }}><CircularProgress size={10} /></div>)}
              </Button>
            </Box>
        </form>
      </Box>
    </DialogContent>
  </Dialog>)
}